<template>
    <div>
      <v-footer absolute :color="skin.primary_color">
        <v-flex align-end>
          <small class="subPrimary--text location">Desarrollado por Epicor® </small>
        </v-flex>
  
        <v-spacer />
  
        <v-spacer />
  
        <v-flex align-end class="subPrimary--text">
          <small>Copyright© {{ new Date().getFullYear() }}. Todos los derechos reservados.</small>
        </v-flex>
      </v-footer>
  
      <v-footer v-if="$isPhoneDevice" absolute :color="skin.primary_color" class="box">
        <v-flex text-xs-center>
          <small class="text-xs-center subPrimary--text">Desarrollado por Epicor® </small>
        </v-flex>
  
        <v-flex class="ml-1 subPrimary--text" text-xs-center>
          <small>Copyright© {{ new Date().getFullYear() }}. Todos los derechos reservados.</small>
        </v-flex>
      </v-footer>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      skin: {
        type: Object,
        required: true
      }
    }
  }
  </script>